module.exports = __webpack_public_path__ + "img/60.33503fe0.png";